module.exports = __webpack_public_path__ + "media/images/marketing/joy-solution-book-b2898bf47ae1654a7fd932c5731bf533e4ac0f1cef7a08842bc1f6d94c1db347.jpg";